import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Select } from '_components';
import { _ } from '_locales';
import styled from 'styled-components';

const Title = styled.h2`
  font-size: 18px !important;
   
  margin-bottom: 20px;
  font-weight: 500 !important;
`;

const alerts = [{
  id: 0,
  label: 'reminder.1_hour_before',
  value: 1,
},
{
  id: 1,
  label: 'reminder.12_hour_before',
  value: 12,
},
{
  id: 2,
  label: 'reminder.24_hour_before',
  value: 24,
},
{
  id: 3,
  label: 'reminder.48_hour_before',
  value: 48,
},
{
  id: 4,
  label: 'reminder.1_week_before',
  value: 7 * 24,
},
];

const AlertReminder = () => {
  const { register } = useFormContext();

  return (
    <div style={{ textAlign: 'center', marginBottom: 40 }}>
      <Title style={{ textAlign: 'center' }}>
        {_('reminder.how_far_in_advance_should_we_send_the_reminder?')}
      </Title>

      <Select
        style={{
          width: '145px',
          fontSize: '16px',
          height: 40,
          paddingLeft: '5px'
        }}
        name="alert"
        selectRef={register}
      >
        {
          alerts.map((alert) => (
            <option
              key={alert.id}
              value={alert.value}
            >
              {_(alert.label)}
            </option>
          ))
        }
      </Select>
    </div>
  );
};

export default AlertReminder;
